import { Sexe } from './Sexe'
import { TraitementDuplicataFicheImpantation_Statut } from './TraitementDuplicataFicheImpantation_Statut'

export class FicheImplantation_DemandeDuplicata {
    id = 0
    date = new Date()
    numeroGreffon = ''
    numeroGreffonCorrect = false
    nomPatient = ''
    prenomPatient = ''
    sexePatient = Sexe.Masculin
    naissancePatient = ''
    nomChirurgien = ''
    utilisateur = ''
    mailReponse = ''
    codeClient = null as null | string
    statut = TraitementDuplicataFicheImpantation_Statut.EnAttenteDeTraitement
}
